module.exports = __webpack_public_path__ + "./fonts/Neucha-Regular.ttf";